import { render, staticRenderFns } from "./DingZhiDesign.vue?vue&type=template&id=9aab1fa2&scoped=true&"
import script from "./DingZhiDesign.vue?vue&type=script&lang=js&"
export * from "./DingZhiDesign.vue?vue&type=script&lang=js&"
import style0 from "./DingZhiDesign.vue?vue&type=style&index=0&id=9aab1fa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aab1fa2",
  null
  
)

export default component.exports